// Track the `LAYOUT_BUILDER_JS_STARTED_EXECUTING` lifecycle (after the JS has been downloaded and parsed
// and is just starting to run). Need to use `Date.now` instead of `performance.now` because the
// iframe's `performance.timing.navigationStart` will not match the parent's `navigationStart`
window.hsQueuedLifecycleTimestamps = window.hsQueuedLifecycleTimestamps || {};
window.hsQueuedLifecycleTimestamps.LAYOUT_BUILDER_JS_STARTED_EXECUTING =
  Date.now();
if (window.performance.mark) {
  window.performance.mark('LAYOUT_BUILDER_STARTED_EXECUTING');
}


window.I18n = window.I18n || {};

window.__hsRoot = {
  globals: [
    // safety for requirejs and other module systems
    'require',
    'requirejs',
    'define',
    'exports',
    'module',
  ],

  saveGlobal: function (globalName) {
    if (typeof window['hspreserve'] === 'undefined') {
      window.hspreserve = {};
    }
    if (typeof window[globalName] != 'undefined') {
      window.hspreserve[globalName] = window[globalName];
      window[globalName] = undefined;
    }
  },

  restoreGlobal: function (globalName) {
    window[globalName] = window.hspreserve[globalName];
  },
};

(function () {
  for (var i = 0; i < window.__hsRoot.globals.length; i++) {
    window.__hsRoot.saveGlobal(window.__hsRoot.globals[i]);
  }
})();


"use strict";
'use es6';

try {
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = parent.__REACT_DEVTOOLS_GLOBAL_HOOK__;
} catch (e) {}
let cdnDomain = 'static.hsappstatic.net';
if (document.location.href.indexOf('localAssets=true') >= 0 || document.domain.indexOf('local.hubspot') >= 0) {
  cdnDomain = 'local.hubspotqa.com';
}
if (typeof window.hubspot === 'undefined') {
  window.hubspot = {};
}
if (typeof window.hubspot.bender === 'undefined') {
  window.hubspot.bender = {};
}
window.hubspot.bender.staticDomainPrefix = `//${cdnDomain}`;






